"use client";

import { SectionLayout } from "@/components/layout/SectionLayout";

interface HeadSpaVisionSectionProps {
  label: string;
  title: string;
  paragraphs: string[];
}

export const HeadSpaVisionSection = ({
  label,
  title,
  paragraphs,
}: HeadSpaVisionSectionProps) => {
  return (
    <SectionLayout
      id="ma-vision"
      className="relative overflow-hidden bg-primary"
    >
      {/* Éléments décoratifs */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute -left-32 top-0 h-96 w-96 rounded-full bg-white blur-3xl" />
        <div className="absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-gold blur-3xl" />
      </div>

      <div className="relative mx-auto flex w-full flex-col gap-12 lg:gap-16">
        <div className="flex flex-col gap-4 text-center">
          <span className="text-sm uppercase tracking-[0.2em] text-gold">
            {label}
          </span>
          <h2 className="font-cormorant text-4xl font-light leading-tight text-white ph:text-5xl sm:text-6xl lg:text-7xl">
            {title}
          </h2>
        </div>

        <div className="flex flex-col gap-8">
          {paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className="text-center text-base leading-relaxed text-white/90 lg:text-lg"
            >
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mx-auto h-px w-24 bg-gold/50" />
      </div>
    </SectionLayout>
  );
};
